const dataUrlToBlob = (dataUrl: string) => {
	const arr = dataUrl.split(',');
	const mime = arr[0].match(/:(.*?);/)[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new Blob([u8arr], { type: mime });
};
const blobToFile = (theBlob: Blob): File => {
	const b: any = theBlob;
	b.lastModifiedDate = new Date();
	b.name = 'image';
	return <File>theBlob;
};

const blobToBase64 = blob => {
	const reader = new FileReader();
	reader.readAsDataURL(blob);
	return new Promise(resolve => {
		reader.onloadend = () => {
			resolve(reader.result);
		};
	});
};

export {
	dataUrlToBlob,
	blobToFile,
	blobToBase64
};
